import React, { useState } from "react";

const ViewInjPalpation = ({ doa, pl, pr }: any) => {

    return (
        <>
            <div className="content container" style={{ maxWidth: "1500px", paddingTop: "10px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row align-items-center">
                                <div className="col d-flex justify-content-between">
                                    <h4>Palpation</h4>
                                </div>
                            </div>
                            <div className="card-body">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th>Date Of Assessment</th>
                                            <th>Palpation Left</th>
                                            <th>Palpation Right</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                            <tr>
                                                <td>{doa}</td>
                                                <td>{pl}</td>
                                                <td>{pr}</td>
                                            </tr>
                                        </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );

}

export default ViewInjPalpation;